const settings = {
  eventDuplicateWait: 1000, // Event duplicate check throttling time
  mainNavHeight: 54,
  reqThrottlingTime: 150, // [ms] some requests like get events are throttled
  synchronizeData: false, // update events, units ... after some chenges been made
  serviceTimeout: 200000,
  maxTabHeight: 300,
  syncTime: 300000, // 5 minutes - server sync time period
};

export default settings;
